// Route prefixes for authenticated app surfaces: pages that own their own
// chrome (auth shell, app shell, settings) and follow the user's appearance
// preference. Everything else is the marketing site, which always renders
// its designed light surface; Dark Lime appears there only as a deliberate
// per-section treatment, never as a theme.
// Keep both lists in sync with the inline pre-paint script in
// app/views/layouts/application.html.erb.
export const APP_SURFACE_PREFIXES = [
  "/sign_in",
  "/sign_out",
  "/dashboard",
  "/prospects",
  "/inquiries",
  "/settings",
  "/identity",
  "/users",
  "/sidekiq",
]

// Exact-match surfaces: /quick itself is the signed-in management list, but
// /quick/:slug is a shared document (or its email gate) opened by external
// prospects, which stays on the marketing theme.
export const APP_SURFACE_PATHS = ["/quick"]

export function isAppSurface(url: string): boolean {
  const path = url.split("?")[0]
  return (
    APP_SURFACE_PATHS.includes(path) ||
    APP_SURFACE_PREFIXES.some(
      (prefix) => path === prefix || path.startsWith(`${prefix}/`),
    )
  )
}
